const touchPadReducer = (state = {}, action) => {
    switch (action.type) {
        case 'ADD_BLOCK_TO_SENTENCE':
            return {...action.block};
        case 'IS_BLOCK_SELECTED':
            return {...action.block};
        case 'PLAY_SCRIPT':
            return {...action};
        case 'UPDATE_BLOCKS':
            return {...state, selectedBlocks: action.blocks};
        case 'SET_CURRENT_PLAYING_ID':
            return {...state, currentPlayingId: action.currentPlayingId, playOneBlockOnly: action.playOneBlockOnly};
        case 'SHOW_ACTIVE_ONLY':
            return {...state,  showActiveOnly: action.showActiveOnly};
        case 'UPDATE_TOPIC_BLOCKS':
            return {...state,  selectedTopic: action.selectedTopic};
        default:
            return state
    }
};

export default touchPadReducer;